React = require 'react'
{ Component, PropTypes } = React
{ connect } = require 'react-redux'
SelectThing = require '../../../a2i/js/components/SelectThing'
classroomsApi = require '../api/classrooms'
LoadingSpinner = require '../../../shared/js/components/LoadingSpinner'

class SelectTeacherContainer extends Component
	@propTypes:
		classroom: PropTypes.object.isRequired
		feedback: PropTypes.object
		reduxFormProps: PropTypes.object
		selectedTeacherId: PropTypes.number

	state:
		fetchError: null
		isLoading: false
		teachers: null

	componentDidMount: =>
		{ classroom } = @props
		@fetchTeachers classroom.id

	componentWillReceiveProps: (newProps) =>
		if newProps.classroom && (newProps.classroom.id != @props.classroom.id)
			@fetchTeachers newProps.classroom.id

	fetchTeachers: (classroomId) =>
		@setState isLoading: true

		@props.fetchTeachers classroomId
		.then (response) =>
			@setState teachers: response.data.list
		.catch (error) =>
			@setState fetchError: error.message
		.then =>
			@setState isLoading: false

	render: =>
		{ feedback, reduxFormProps } = @props
		{
			fetchError,
			isLoading,
			teachers
		} = @state

		React.createElement(SelectThing, { \
			"error": (fetchError),  \
			"feedback": (feedback),  \
			"isFetching": (isLoading),  \
			"nameField": "name",  \
			"reduxFormProps": (reduxFormProps),  \
			"selectedThingId": (@props.selectedTeacherId),  \
			"thingName": ('teacher'),  \
			"things": (teachers),  \
			"zeroThingsMessage": "There are no teachers assigned to this classroom"
		})

mapStateToProps = (state) ->
	return {}

mapDispatchToProps = {
	fetchTeachers: classroomsApi.teachers
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(SelectTeacherContainer)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/SelectTeacher.cjsx